import React from "react";

import TextSide from "./components/TextSide";
import VideoSide from "./components/VideoSide";

import classes from "./index.module.css";

const About = () => {
  return (
    <div id="about" className={classes["wrapper"]}>
      <TextSide />
      <VideoSide />
    </div>
  );
};

export default About;
